import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { captureReferralParam } from './lib/referral';
import { initTma } from './lib/tma';
import './styles/index.css';

initTma();
// До рендера: роутер может изменить URL и потерять ?ref=
captureReferralParam();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
